import { useTranslation } from 'next-i18next'
// Dependencies.
import { useState } from 'react'

import { SectionField } from '../../Inputs/SectionField'
import { TextArea } from '../../Inputs/TextArea'
import { EventHookInterface } from '../../../types'

// Props.
interface Props {
  eventHook: EventHookInterface
}

// How To Participate.
export const HowToParticipate: React.FC<Props> = (props) => {
  const { t } = useTranslation('common')

  // Props.
  const { eventHook } = props

  // State.
  const { isEditable } = eventHook
  const howToParticipate = eventHook.value.participation_descr
  const setHowToParticipate = (participation_descr: string) =>
    eventHook.updateFieldsWithPartial({ participation_descr })

  // ..
  if (howToParticipate === '') return null
  return (
    <SectionField
      header={t(`How to participate`, `How to participate`)}
      subheader={
        isEditable &&
        'Add an optional description of what attendees can expect to experience when they join the event'
      }>
      <TextArea
        onChange={setHowToParticipate}
        placeholder={t(`Add description`, `Add description`)}
        // readOnly={!isEditable}
        readOnly={true}
        value={howToParticipate}
      />
    </SectionField>
  )
}
